import React from "react";
import PublicLayout from "../layout/PublicLayout";
import LegalLink from "./LegalLink";
import AcceptTermsButton from "./AcceptTermsButton";

const SECTION_HEADING_RE = /^\d+\.\s/;

function renderParagraphs(text) {
  const paragraphs = (text || "").split(/\n\n+/).map((p) => p.trim()).filter(Boolean);
  return paragraphs.map((para, i) => {
    const lines = para.split("\n");
    const isSectionHeading = SECTION_HEADING_RE.test(lines[0]);
    if (isSectionHeading) {
      return (
        <div key={i} className="pt-4">
          <h2 className="font-display text-xl font-semibold tracking-tight">{lines[0]}</h2>
          {lines.slice(1).map((line, j) => (
            <p key={j} className="text-sm text-muted-foreground leading-relaxed mt-2">{line}</p>
          ))}
        </div>
      );
    }
    return lines.map((line, j) => (
      <p key={`${i}-${j}`} className="text-sm text-muted-foreground leading-relaxed">{line}</p>
    ));
  });
}

export default function LegalDocument({ eyebrow, title, text, relatedLinks, loading }) {
  if (loading) {
    return (
      <PublicLayout>
        <div className="mx-auto max-w-3xl px-4 py-20 text-center text-muted-foreground">Loading…</div>
      </PublicLayout>
    );
  }

  return (
    <PublicLayout>
      <section className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-[10px] uppercase tracking-[0.2em] text-accent font-bold mb-3">{eyebrow}</div>
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight mb-8">{title}</h1>
        <div className="space-y-4">{renderParagraphs(text)}</div>

        {relatedLinks && relatedLinks.length > 0 && (
          <div className="mt-8 pt-4 border-t border-border flex flex-wrap gap-x-6 gap-y-2 text-sm">
            <span className="text-muted-foreground">Also see:</span>
            {relatedLinks.map((l) => (
              <LegalLink key={l.to} to={l.to} className="text-primary hover:underline">{l.label}</LegalLink>
            ))}
          </div>
        )}

        <div className="mt-8">
          <AcceptTermsButton />
        </div>
      </section>
    </PublicLayout>
  );
}
